<template>
    <div class="left">
        <el-menu
            router
            unique-opened
            :default-active="$route.path"
            class="el-menu-vertical-demo"
            :collapse-transition=false
            @open="handleOpen"
            @close="handleClose">
            <el-submenu index="1">
                <template slot="title">
                <i class="el-icon-s-grid"></i>
                <span>委托单分类管理</span>
                </template>
                <el-menu-item index="/">
                    <i class="el-icon-edit"></i>
                    <span>材料检测委托合同</span>
                </el-menu-item>
                <el-menu-item index="/luji">
                    <i class="el-icon-message"></i>
                    <span>路基路面检测委托合同</span>
                </el-menu-item>
            </el-submenu>
            <!-- <el-submenu index="2">
                <template slot="title">
                <i class="el-icon-s-management"></i>
                <span>检测任务单管理</span>
                </template>
                <el-menu-item index="/jianceCailiao">
                    <i class="el-icon-edit"></i>
                    <span>材料检测</span>
                </el-menu-item>
                <el-menu-item index="/jianceLuji">
                    <i class="el-icon-message"></i>
                    <span>路基路面检测</span>
                </el-menu-item>
            </el-submenu> -->
            <el-menu-item index="/renwu">
                <i class="el-icon-s-management"></i>
                <span slot="title">检测任务单管理</span>
            </el-menu-item>
            <el-menu-item index="/danwei">
                <i class="el-icon-s-check"></i>
                <span slot="title">委托单位管理</span>
            </el-menu-item>
            <el-menu-item index="/xiangmu">
                <i class="el-icon-s-promotion"></i>
                <span slot="title">检测项目管理</span>
            </el-menu-item>
            <el-menu-item index="/yiju">
                <i class="el-icon-s-claim"></i>
                <span slot="title">检测依据管理</span>
            </el-menu-item>
            <el-submenu index="6">
                <template slot="title">
                <i class="el-icon-s-marketing"></i>
                <span>统计管理</span>
                </template>
                <el-submenu index="6-1">
                <template slot="title">
                    <i class="el-icon-collection"></i>
                    <span>订单管理</span>
                </template>
                <el-menu-item index="/orderCailiao">材料检测委托单</el-menu-item>
                <el-menu-item index="/orderLuji">路面路基检测委托单</el-menu-item>
                <el-menu-item index="/orderJiance">检测任务单</el-menu-item>
                </el-submenu>
                <el-submenu index="6-2">
                <template slot="title">
                    <i class="el-icon-document-copy"></i>
                    <span>财务管理</span>
                </template>
                <el-menu-item index="/yingshou">应收款</el-menu-item>
                <el-menu-item index="/huikuan">回款单</el-menu-item>
                <el-menu-item index="/hkaccount">账户管理</el-menu-item>
                </el-submenu>
            </el-submenu>
            <el-menu-item index="/reportTemplate">
                <i class="el-icon-s-order"></i>
                <span slot="title">选择报告模板</span>
            </el-menu-item>
            <el-menu-item index="/reportFile">
                <i class="el-icon-s-claim"></i>
                <span slot="title">检测报告存档</span>
            </el-menu-item>
        </el-menu> 
    </div>
  </template>

  <script>
      export default {
          data () {
              return {
                
              }
        },
        methods: {
            handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            }
        }
      }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
      
  </style>
  


// WEBPACK FOOTER //
// src/components/common/left.vue